import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-[#ff0000] rounded-lg flex items-center justify-center">
                <i className="ri-fire-line text-white text-2xl"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold leading-tight text-white">
                  JUSTCLEAN
                </span>
                <span className="text-xs font-semibold text-[#ff0000] leading-tight">
                  INCENDIOS
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-300 mb-4">
              Especialistas en limpieza post incendio en Barcelona. Intervención rápida, protocolos profesionales y coordinación con aseguradoras.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-300 hover:text-[#ff0000] transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-sm text-gray-300 hover:text-[#ff0000] transition-colors">
                  Empresa
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-sm text-gray-300 hover:text-[#ff0000] transition-colors">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-gray-300 hover:text-[#ff0000] transition-colors">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-sm text-gray-300 hover:text-[#ff0000] transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Limpieza de hollín y humo</li>
              <li>Neutralización de olores</li>
              <li>Retirada de residuos</li>
              <li>Desinfección y saneamiento</li>
              <li>Limpieza de cocinas</li>
              <li>Preparación para pintura</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-[#ff0000] mt-1 mr-3"></i>
                <div>
                  <a href="tel:+34602365996" className="text-sm text-gray-300 hover:text-[#ff0000] transition-colors">
                    +34 602 36 59 96
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-[#ff0000] mt-1 mr-3"></i>
                <div>
                  <a href="mailto:info@incendios.justclean.es" className="text-sm text-gray-300 hover:text-[#ff0000] transition-colors">
                    info@incendios.justclean.es
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-[#ff0000] mt-1 mr-3"></i>
                <div className="text-sm text-gray-300">
                  Barcelona y provincia
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © {currentYear} JUSTCLEAN INCENDIOS. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-4 text-sm text-gray-400">
            <a href="#" className="hover:text-[#ff0000] transition-colors">Aviso Legal</a>
            <span>·</span>
            <a href="#" className="hover:text-[#ff0000] transition-colors">Privacidad</a>
            <span>·</span>
            <a href="#" className="hover:text-[#ff0000] transition-colors">Cookies</a>
            <span>·</span>
            <a href="https://www.justclean.es/" target="_blank" rel="noopener noreferrer" className="hover:text-[#ff0000] transition-colors">
              Powered by Justclean
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
